import React, { Component } from 'react';
import QRCodeGenerator from '../qrCode/QRCodeGenerator';
import { Row, Col, Button, Divider } from 'antd';
import './ExportPreview.css'
import moment from 'moment';
import logo from '../../assets/images/new_logo.png'
import HOME from '../../constants/home-constant';
import html2pdf from 'html2pdf.js';
import html2canvas from 'html2canvas';
import FileSaver from 'file-saver';

class ExportPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: (this.props.data instanceof Array ? this.props.data : [this.props.data])
    }
    this.filename = this.props.home?.currentData instanceof Array ? this.props.home.currentData[0].testname : this.props.home.currentData.testname;
  }
  filename;

  exportToPNG = () => {
    setTimeout(() => {
      let element = document.getElementById('exportContent');
      if(element) {
        html2canvas(element).then((canvas) => {
          if (canvas.msToBlob) {
            var blob = canvas.msToBlob();
            window.navigator.msSaveBlob(blob, `${this.filename}.png`);
          } else {
            FileSaver.saveAs(canvas.toDataURL(), `${this.filename}.png`);
          }
        });
      }
    }, 1000);
    
    
  }

  isChecked = (field) => {
    return this.props.home[field];
  }

  getClassName = (field) => {
    return (this.isChecked(field) ? "check-square" : "border")
  }

  exportPDF = (isExportPdf) => {
    const element = document.getElementById('exportContent');
    const opt = {
      margin:       10,
      filename:     `${this.filename}.pdf`,
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas:  { scale: 2 },
      jsPDF:        { 
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts:true
      }
    };

    if(isExportPdf){
      html2pdf().from(element).set(opt).save();
    }else {
      window.print();
    } 
  }

  goBack = () => {
    ['date', 'parameter', 'description'].map((props) => { 
      this.props.dispatch({
        type: HOME.SET_PROP,
        value: false,
        prop: props
      })
    });

    this.props.dispatch({ type: HOME.SET_PROP, value: false, prop: 'previewData' })
  }

  render() {
    const ref = React.createRef();
    const getTradeMark = () => <span className="sup"><font size="2">®</font></span>

    return (
      <div>
        <Row gutter={[16, 8]}>
          <Col span={24} align="right">
            <Row gutter={[16, 16]}>
              <Col span={20} align="left">
                <Button type="primary" size="small" onClick={() => this.goBack()}>Back</Button>
              </Col>
              {(this.props.home.exportTo === '3') ? <Col span={4}>
                <Button type="primary" size="small" onClick={() => this.exportPDF(false)}>Print</Button>
              </Col> : ""}
              {(this.props.home.exportTo === '1') ? <Col span={4}>
                <Button type="primary" size="small" onClick={() => this.exportToPNG()}>Export PNG</Button>
              </Col> : ""}
              {(this.props.home.exportTo === '0') ? <Col span={4}>
                <Button onClick={() => this.exportPDF(true)} type="primary" size="small">Export PDF</Button>
              </Col> : ""}
            </Row>
          </Col>
          <Col span={24}>
            <div ref={ref} id="exportContent">
              <Row>
                <Col span={15}>
                  <h3>ReadyStream{getTradeMark()} Data Matrix Generator</h3>
                </Col>
                <Col span={9} align="right">
                  <p><small>Printed: {moment().format('MMMM Do YYYY, h:mm:ss a')}</small></p>
                </Col>
              </Row>
              <Divider style={{ margin: '5px 0' }} />
              <h5>TEST Data matrix</h5>
              {(this.props.home.currentData || []).map((a, key) => (<Row key={key} gutter={[16, 26]}>
                <Col span={24}>
                  <table className="w-100">
                    <tbody>
                      <tr>
                        <td>
                          <table border="1" className="w-100" cellPadding="0">
                            <tbody>
                              <tr>
                                <td className="w-90 p-5">
                                  <QRCodeGenerator value={a} size={100} />
                                </td>
                                <td className="pt-0 pb-0" valign="top">
                                  <table border="1" className="w-100 header-bg">
                                    <tbody>
                                      <tr>
                                        <th><h6>Test Name</h6></th>
                                        {this.isChecked('parameter') ?
                                          (<React.Fragment>
                                            <th><h6>Volume</h6></th>
                                            <th><h6>Conc.</h6></th>
                                            <th><h6>Flow</h6></th>
                                          </React.Fragment>)
                                          : ""}
                                        {this.isChecked('description') ? <th><h6>Description</h6></th> : ""}
                                      </tr>
                                      <tr>
                                        <td><h6>{a.testname}</h6></td>
                                        {this.isChecked('parameter') ?
                                          (<React.Fragment>
                                            <td><h6>{(a.volume || a.mediavolume) + " ml"}</h6></td>
                                            <td><h6>{a.concentration}</h6></td>
                                            <td><h6>{(a.flowrate || a.dispinseflow) + " l/mn"}</h6></td>
                                          </React.Fragment>)
                                          : ""}
                                        {this.isChecked('description') ? <td><h6>{a.description || a.desc}</h6></td> : ""}
                                      </tr>
                                      <tr>
                                        {this.isChecked('date') ? <th><h6>Date</h6></th> : ""}
                                        {this.isChecked('parameter') ?
                                          (<React.Fragment><th><h6>Heating</h6></th>
                                            <th><h6>Temp.</h6></th>
                                            <th><h6>Priority</h6></th></React.Fragment>)
                                          : ""}
                                        {this.isChecked('createdBy') ? <th><h6>Created By</h6></th> : ""}
                                      </tr>
                                      <tr>
                                        {this.isChecked('date') ? <td><h6>{a.date || a.datepicker.format('YYYY-MM-DD')}</h6></td> : ""}
                                        {this.isChecked('parameter') ?
                                          (<React.Fragment>
                                            <td><h6>{((a.temperature) ? 'Yes' : 'No')}</h6></td>
                                            <td><h6>{a.temperature || a.temperature === 0 ?  a.temperature : "-"} </h6></td>
                                            <td><h6>{(a.priority || 'Flow')}</h6></td>
                                          </React.Fragment>)
                                          : ""}
                                        {
                                          this.isChecked('createdBy') ? (
                                            <td><h6>{a.createdFor || a.createdby}</h6>
                                          </td>) : ""
                                        }
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>))}
              <Row>
                <Col style={{ textAlign: 'right' }}>
                  <img src={logo} alt="logo" className="logo-img" />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default ExportPreview;